fetch('https://geoip.maltertech.com/')
    .then(response => response.json())
    .then(data => {
        // If Hawaii or Alaska, hide shipping bar
        if (data.region === "Alaska" || data.region === "Hawaii" || data.country_code === "CA") {
            document.querySelector("#miniCartHeaderShipping").classList.add("hidden");
            document.querySelector("#miniCartHeaderBar").classList.add("hidden");
        }

        // if on the PDP, update shipping message
        const pdpShippingMessage = document.querySelector("#productInnerContentShipping");
        if (pdpShippingMessage) {
            if (data.region === "Alaska" || data.region === "Hawaii") {
                pdpShippingMessage.innerHTML = "Alaska/Hawaii Shipping: $29.99 up to 48oz. $59.99 over 48oz.";
            } else if (data.country_code === "US") {
                pdpShippingMessage.innerHTML = "US Flat Rate Shipping: $9.99 / Free Shipping on $50+";
            } else if (data.country_code === "CA") {
                pdpShippingMessage.innerHTML = "Canada Flat Rate Shipping: $19.99";
            }
        }
    });


/**************
 Cart
 ***************/

// Order note dropdown
document.querySelector("#miniCartNoteTop").addEventListener("click", function () {
    document.querySelector("#miniCartNoteTopWrap").classList.toggle("active");
    document.querySelector("#miniCartNoteBottom").classList.toggle("active");
});


// open cart
async function openCart(skipFetch = false) {
    // reset container
    document.querySelector("#miniCartBody").innerHTML = "";

    // fetch cart
    if (skipFetch === false) {
        cart = await fetch("/cart.js")
            .then(function (data) {
                return data.json();
            });
    }


    // update cart count
    document.querySelector("#headerLowerBodyBtnsItemCount").innerHTML = cart.item_count;

    // update active body
    if (cart.item_count === 0) {
        document.querySelector("#miniCartHeader").removeAttribute("data-count");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        document.querySelector("#miniCartUpsell").classList.add("hidden");
        document.querySelector("#miniCartNote").classList.remove("active");


    } else {
        document.querySelector("#miniCartHeader").setAttribute("data-count", cart.item_count);
        document.querySelector("#miniCartBody").classList.add("active");
        document.querySelector("#miniCartEmpty").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.add("active");
        document.querySelector("#miniCartUpsell").classList.remove("hidden");
        document.querySelector("#miniCartNote").classList.add("active");


        // update subtotal
        document.querySelector("#miniCartFooterTotal span:last-child").textContent = price(cart.items_subtotal_price);
    }

    // Free shipping bar
    if (cartSettings.enable_free_shipping_bar && country !== 'Canada') {
        if ((freeShippingThreshold * 100) < cart.total_price) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").style.width = "100%";
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "Spend <b>" + price((freeShippingThreshold * 100) - cart.total_price) + "</b> more to get <b>FREE</b> shipping";
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / (freeShippingThreshold * 100)) * 100}%`;
        }
    }


    // append cart
    cart.items.forEach(function (item) {
        // variant HTML
        function variantHTML() {
            // loop over options_with_values
            let options = "";
            options += `<div class="miniCartBodyItemVariant">`;
            item.options_with_values.forEach(function (option) {
                options += `${option.name}: ${option.value}<br>`;
            });
            options += `</div>`;

            // check for Default
            if (options.includes("Default Title")) {
                return ""
            }

            return options;
        }

        // gift card HTML
        function giftCardHtml() {
            if (item.properties) {
                let properties = [];
                Object.keys(item.properties).forEach(function (key) {
                    if (key.includes('Recipient name')) {
                        properties.push("Recipient name: " + item.properties[key]);
                    }
                    if (key.includes('Recipient email')) {
                        properties.push("Recipient email: " + item.properties[key]);
                    }

                });

                let propertiesString = "";
                properties.forEach(function (property) {
                    propertiesString += `<div class="miniCartBodyItemProperty">${property}</div>`;
                });

                return `<div class="miniCartBodyItemProperty">${propertiesString}</div>`;
            }
            return "";
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200">
                <div>
                     <div class="miniCartBodyItemRow">
                        <div class="miniCartBodyItemRowTitle">${item.product_title}</div>
                         <div class="miniCartBodyItemRowPrice">${price(item.final_line_price)} <s>${item.original_line_price > item.final_line_price ? price(item.original_line_price) : ""}</s></div>
                     </div>
                    ${variantHTML()}
                    ${giftCardHtml()}
                    ${subscriptionHTML()}
                     <div class="miniCartBodyItemRow">
                         <div class="miniCartBodyItemRowQty">
                        <button class="miniCartBodyItemRowQtyMinus" aria-label="Quantity Minus">
                            <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 12L18 12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                      
                        <div class="miniCartBodyItemRowQtyCount">${item.quantity}</div>
                        <button class="miniCartBodyItemRowQtyPlus" aria-label="Quantity Plus">
                            <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H11V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H13V3Z" fill="#0F0F0F"/>
                            </svg>
                        </button>
                    </div>
                    <button class="miniCartBodyItemRowTrash">Remove</button>
                    </div>
                </div>
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemRowQtyCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemRowQtyMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRowTrash").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemRowQtyPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRowTrash").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemRowQtyCount`).textContent = quantity;

            // update cart in shopify
            let response = await changeProduct({
                id: key,
                quantity: quantity
            });

            // check for error
            if (response.status === 422) {
                alert("No more in stock.");
            } else {
                cart = response;
            }

            // update active body
            await openCart(true);
        }
    });


    // Update Cart Note
    document.querySelector("#miniCartNoteBottomWrapContentTextarea").value = cart.note;


    // check if upsell in cart - if so hide upsell
    if (cart.items.find(item => item.product_id === parseInt(document.querySelector('#miniCartUpsellContentATC').dataset.id))) {
        document.querySelector('#miniCartUpsell').classList.add('active');
    } else {
        document.querySelector('#miniCartUpsell').classList.remove('active');
    }

    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("#miniCart").classList.add("active");
    document.querySelector('#miniCartContent').classList.add('active');
    document.querySelector("body").classList.add("noScroll");
}

// listen for add upsell
document.querySelector('#miniCartUpsellContentATC').addEventListener('click', async function () {
    // add loading
    this.classList.add("loading");


    // get product id
    let productId = this.dataset.product

    // add product to cart
    await addProduct({
        id: productId,
        quantity: 1
    });

    // update active body
    await openCart();

    // remove loading
    this.classList.remove("loading");
});


// close cart
function closeCart() {
    document.querySelector('#miniCartContent').classList.remove('active');
    document.querySelector("#miniCart").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");

    // Wait before closing - allows animation to complete
    setTimeout(function () {
        document.querySelector("#miniCart").close();
    }, 400);
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", openCart);
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    // update order note if it does not match shopify
    if (document.querySelector("#miniCartNoteBottomWrapContentTextarea").value !== cart.note) {
        await updateCart({"note": document.querySelector("#miniCartNoteBottomWrapContentTextarea").value});
    }

    window.location.href = "/checkout";
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));